document.addEventListener('DOMContentLoaded', function () {
        console.log('DOM加载完成 - 滚动动画');

        if (typeof jQuery === 'undefined' || typeof $ === 'undefined') {
          console.error('jQuery 未加载 - 滚动动画');
          return;
        }

        // 统一的动画处理函数
        function handleScrollAnimation() {
          var $window = $(window);
          var scrollTop = $window.scrollTop();
          var windowHeight = $window.height();
          var triggerOffset = 60;

          $('.animate-js').each(function () {
            var $element = $(this);
            var elementTop = $element.offset().top;

            // 判断元素是否进入视窗
            if (scrollTop + windowHeight - triggerOffset > elementTop) {
              $element.addClass('animated');
            } else {
              $element.removeClass('animated');
            }
          });
        }

        // 初始化执行一次
        handleScrollAnimation();

        // 监听滚动事件
        $(window).on('scroll', handleScrollAnimation);
      });